import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/ai-astrologer/page.tsx");
